export default __webpack_public_path__ + "static/media/compass-needle-5024_256.938f7330.gif";